import { useLanguage } from '../../i18n/LanguageContext';
import type { Showroom } from '../../services/dealerApi';

interface ShowroomPickerProps {
  name: string;
  showrooms: Showroom[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

/** Spec 085 (G7, Flow H step 2) — one of the dealer's ACTIVE showrooms as the pickup or return point. */
export default function ShowroomPicker({ name, showrooms, selectedId, onSelect }: ShowroomPickerProps) {
  const { t } = useLanguage();
  if (showrooms.length === 0) {
    return <p className="dealer-hint">{t('dealer.wizard.noShowrooms')}</p>;
  }
  return (
    <div className="dealer-choice-list" role="radiogroup">
      {showrooms.map((s) => (
        <label key={s.id} className={`dealer-choice${selectedId === s.id ? ' dealer-choice--selected' : ''}`}>
          <input type="radio" name={name} checked={selectedId === s.id} onChange={() => onSelect(s.id)} />
          <span className="dealer-choice__main">
            <strong>{s.label}</strong>
            <span className="dealer-muted">{[s.building, s.street, s.area, s.city, s.emirate].filter(Boolean).join(', ')}</span>
          </span>
        </label>
      ))}
    </div>
  );
}
